export default __webpack_public_path__ + "static/media/closeIconShare.9aa90704.svg";